import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Material } from '../../models/material.model';
import { PermissionHelper } from '../../helpers/permission.helper';
@Component({
  standalone: false,
  selector: 'app-material',
  templateUrl: './material.component.html',
})
export class MaterialComponent {
  @Input() material: Material;
  @Input() isAdditional: boolean;
  @Input() isSelected: boolean;
  @Input() isMaterialExpanded: boolean;
  @Input() userSectors: Array<string>;
  @Input() exchangeRate: number;
  @Output() readonly approveMaterial = new EventEmitter();
  @Output() readonly deleteMaterial = new EventEmitter();
  @Output() readonly selectMaterial = new EventEmitter();

  isCollapsed: boolean = false;

  constructor(public permissionHelper: PermissionHelper) {}

  onExpandMaterial(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onApproveMaterial(material: Material): void {
    this.approveMaterial.emit(material);
  }

  onDeleteMaterial(material: Material): void {
    this.deleteMaterial.emit(material);
  }

  onSelectMaterial(material: Material): void {
    this.selectMaterial.emit(material);
  }

  // showDecimals(price: number): number {
  //   return this.customFunctions.showDecimals(price);
  // }
}
